import React, { useState } from "react";
import ROUTES from "../../constants/routes";
import { UpgradeCard } from "../../../components";
import ModalVideo from "react-modal-video";
import { useNavigate } from "react-router-dom";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { loadCampaigns } from "../../../redux/actions/premium/dashboardActions";
import HelpButton from "../../../components/button/helpButton";

// get user data from state
const authData = (state) => state.auth;

function CurrentPlanPage(props) {
  const data = useSelector(authData);

  const [isOpen, setOpen] = useState(false);
  const [upgrade, setUpgrade] = useState(false);
  let navigate = useNavigate();

  // Redirect to create assesstment
  let proceed = () => {
    let clientCampaigns = data && data.client && data.client.campaigns;

    if (clientCampaigns >= 1) {
      navigate(`${ROUTES.DASHBOARD}`, { replace: true });
    } else {
      props.loadCampaigns();
      navigate(`${ROUTES.WELCOME}`, { replace: true });
    }
  };

  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };
  return (
    <>
      {isOpen ? (
        <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpen}
          videoId="7Wb7-_3NpSw"
          onClose={() => setOpen(false)}
        />
      ) : upgrade ? (
        <UpgradeCard type="PREMIUM" onCloseUpgrade={onCloseUpgrade} />
      ) : (
        <div className="2xl:w-6/12 z-20 xl:w-6/12 lg:w-7/12 md:w-8/12 w-10/12  mt-16 bg-white drop-shadow-md rounded-lg  py-10   md:px-8 px-6">
          <div>
            {/* begin::Heading */}
            <div className="text-center">
              <h1 className="2xl:text-4xl xl:text-4xl lg:text-3xl md:text-4xl text-3xl font-bold text-[#292929]">
                Your Current Plan:{" "}
                <span className="2xl:text-4xl xl:text-4xl lg:text-3xl md:text-4xl text-3xl font-bold  text-[#007E8C]">
                  PREMIUM
                </span>
              </h1>
            </div>
            {/* begin::Heading */}
            {/* begin::Description */}
            <div className="flex 2xl:flex-row justify-around items-center xl:flex-row lg:flex-row md:flex-col flex-col mt-10">
              <div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    1200 Candidate Assessments
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    2 Assessment Games
                  </span>
                </div>
                <div className="flex flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Access to our Test Library
                  </span>
                </div>
                <div className="flex  flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Pre selected fields of data collection
                  </span>
                </div>
                <div className="flex  flex-row items-center flex-wrap my-2">
                  <CheckCircleIcon className="text-[#007E8C] 2xl:block xl:block lg:block  h-6 w-6 rounded-full mr-2 " />
                  <span className="text-sm text-[#3B4345] font-semibold">
                    Customizable fields
                  </span>
                </div>
              </div>

              <div className="relative ">
                <p className="text-[#FEBB12] text-[5rem] font-bold">
                  {data?.planType === "quarterly" ? "1500" : "4,800"}<sup className="text-[2.5rem] font-bold top-[-3rem]">$</sup>
                </p>
                {/* <p className="text-[#FEBB12] text-[2.5rem] font-bold absolute top-[-1.2rem] left-[12rem]">
                  $
                </p> */}
                <p className="text-[#007E8C6E] font-bold text-3xl fixed right-10 -mt-6">
                  {data?.planType === "quarterly" ? "Per Quarter" : "Per Year"}
                </p>
              </div>
            </div>
            {/* begin::Description */}
            {/* begin:: Button */}

            <div className="mt-8 flex flex-col justify-center items-center">
              {/* <Button
                type="button"
                customStyle="2xl:w-6/12 xl:w-6/12 lg:w-6/12 md:8/12 w-11/12"
                name="Upgrade Your Plan"
                onClick={() => updatePlan()}
              /> */}
              <button
                className="capitalize text-lg rounded font-bold shadow-md px-6 py-3 mt-3  2xl:w-6/12 xl:w-6/12 lg:w-6/12 md:8/12 w-11/12 text-[#007E8C]   bg-[#FFD700] hover:bg-[#f1cd2b]"
                name="Proceed"
                onClick={() => proceed()}
              >
                Proceed
              </button>
            </div>

            {/* begin:: Button */}
          </div>
        </div>
      )}

      <HelpButton screen="login" />
    </>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { loadCampaigns })(CurrentPlanPage);
